import { ReactElement, ReactNode } from "react";
import { useDisclosure, Icon, ModalProps, MenuItem } from "@chakra-ui/react";
import { MdMergeType } from "react-icons/md";
import MergeModal from ".";

export type RenderContentProps = {
  formId: string;
  onClose: () => void;
  setIsLoading: (isLoading: boolean) => void;
};

type Props = Pick<ModalProps, "size"> & {
  formId?: string;
  isDisabled?: boolean;
  label: ReactNode;
  renderContent: (props: RenderContentProps) => ReactElement;
  submitLabel?: ReactNode;
};

export default function MergeModalMenuItem({
  formId,
  isDisabled,
  label,
  renderContent,
  size,
  submitLabel,
}: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <MenuItem
        icon={<Icon as={MdMergeType} />}
        onClick={onOpen}
        isDisabled={isDisabled}
      >
        {label}…
      </MenuItem>

      <MergeModal
        {...{
          formId,
          isDisabled,
          isOpen,
          label,
          onClose,
          renderContent,
          size,
          submitLabel,
        }}
      />
    </>
  );
}
